import React, { useState, useEffect, Fragment } from "react";

import { NavLink as BSNavLink, withRouter } from "react-router-dom";
import { Navbar, Container } from "react-bootstrap";
import LanguageSelector from "./LanguageSelector";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { GoogleTracking } from "../google/GoogleTracking";
import logoDark from "../../assets/img/clients-logo/logo-dark.svg";

const TopNav = (props) => {
  const { t, i18n } = useTranslation();
  const [isTop, setIsTop] = useState(true);
  const [expanded, setExpanded] = useState(false);
  const blogs = useSelector((state) => state.main.blogs);
  const galleryCount = useSelector((state) => state.main.gallery_count);
  const appSettings = useSelector((state) => state.main.settings);

  useEffect(() => {
    const onScroll = () => {
      const currentTop = window.scrollY < 100;
      if (currentTop !== isTop) {
        setIsTop(currentTop);
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll, { passive: true });
    };
  });

  return (
    <Fragment>
      <Navbar
        collapseOnSelect
        id="mainNav"
        expanded={expanded}
        expand="lg"
        className="navbar-scrolled navbar-light fixed-top py-2 saa_shadow"
        bg="*"
        variant="*"
      >
        <Container>
          <BSNavLink
            className="logo"
            to={`/${i18n.language}/`}
            style={{
              minHeight: "54px",
            }}
          >
            <LazyLoadImage
              alt="Logo"
              src={logoDark}
              className="top-main-logo"
              height={"45"}
            />
          </BSNavLink>

          <Navbar.Toggle
            aria-controls="navbarResponsive"
            onClick={() => setExpanded(expanded ? false : "expanded")}
          >
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </Navbar.Toggle>

          <Navbar.Collapse id="navbarResponsive">
            <ul className="ml-auto navbar-nav my-2 my-lg-0">
              <li className="nav-item">
                <BSNavLink
                  exact
                  onClick={() => setExpanded(false)}
                  className="nav-link"
                  to={`/${i18n.language}/`}
                >
                  {t("TOP_NAV_HOME_LABEL")}
                </BSNavLink>
              </li>
              <li className="nav-item">
                <BSNavLink
                  onClick={() => setExpanded(false)}
                  className="nav-link"
                  to={`/${i18n.language}/about`}
                >
                  {t("TOP_NAV_ABOUT_LABEL")}
                </BSNavLink>
              </li>
              {/* <li className="nav-item">
                <BSNavLink
                  onClick={() => setExpanded(false)}
                  className="nav-link"
                  to={`/${i18n.language}/causes/search`}
                >
                  {t("TOP_NAV_CAUSES_LABEL")}
                </BSNavLink>
              </li> */}
              {blogs.length > 0 ? (
                <li className="nav-item">
                  <BSNavLink
                    onClick={() => setExpanded(false)}
                    className="nav-link"
                    to={`/${i18n.language}/blog`}
                  >
                    {t("TOP_NAV_BLOG_LABEL")}
                  </BSNavLink>
                </li>
              ) : null}
              <li className="nav-item">
                <BSNavLink
                  onClick={() => setExpanded(false)}
                  className="nav-link"
                  to={`/${i18n.language}/marital-therapy-clinic`}
                >
                  {t("DR_MAGDI_CLINIC_TOP_HEADER")}{" "}
                  {/* <span className="badge badge-primary">
                    {t("WEBSITE_BADGE_NEW")}
                  </span> */}
                </BSNavLink>
              </li>
              {galleryCount > 0 ? (
                <li className="nav-item">
                  <BSNavLink
                    onClick={() => setExpanded(false)}
                    className="nav-link"
                    to={`/${i18n.language}/gallery`}
                  >
                    {t("GALLERY_TOP_HEADER")}{" "}
                    <span className="badge badge-primary">
                      {t("WEBSITE_BADGE_NEW")}
                    </span>
                  </BSNavLink>
                </li>
              ) : null}
              <li className="nav-item">
                <BSNavLink
                  onClick={() => setExpanded(false)}
                  className="nav-link"
                  to={`/${i18n.language}/contact`}
                >
                  {t("TOP_NAV_CONTACT_LABEL")}
                </BSNavLink>
              </li>
              <LanguageSelector
                setExpanded={setExpanded}
                selectedLang={props.selectedLang}
                setSelectedLang={props.setSelectedLang}
              />
              <li className="nav-item">
                <BSNavLink
                  className="nav-link btn btn-primary"
                  to="route"
                  onClick={(_e) => {
                    _e.preventDefault();
                    if (
                      appSettings.static_button_get_started_ga_label &&
                      appSettings.static_button_get_started_ga_action &&
                      appSettings.static_button_get_started_ga_category
                    )
                      GoogleTracking({
                        ga_data: {
                          type: "event",
                          data: {
                            category:
                              appSettings.static_button_get_started_ga_category
                                ? appSettings.static_button_get_started_ga_category
                                : "1 - Donations",
                            action:
                              appSettings.static_button_get_started_ga_action
                                ? appSettings.static_button_get_started_ga_action
                                : "Donate Now",
                            label:
                              appSettings.static_button_get_started_ga_label
                                ? appSettings.static_button_get_started_ga_label
                                : "Donate Now button - Top Nav",
                          },
                        },
                      });
                    const targetUrlType =
                      appSettings.static_button_get_started_url_type
                        ? appSettings.static_button_get_started_url_type
                        : "internal";
                    const targetUrl = appSettings.static_button_get_started_url
                      ? appSettings.static_button_get_started_url
                      : `/cause/help-us`;
                    if (targetUrlType.toLowerCase() === "external") {
                      window.open(targetUrl);
                    } else {
                      props.history.push(`/${i18n.language}${targetUrl}`);
                    }
                    setExpanded(false);
                  }}
                >
                  {appSettings.static_button_get_started_label
                    ? t(appSettings.static_button_get_started_label)
                    : t("TOP_NAV_STATIC_BUTTON_GET_STARTED_LABEL")}
                </BSNavLink>
              </li>
            </ul>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </Fragment>
  );
};

export default withRouter(TopNav);
